import { render } from "./AppAlerts.vue?vue&type=template&id=a3006912&scoped=true&ts=true&lang=pug"
import script from "./AppAlerts.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppAlerts.vue?vue&type=script&lang=ts&setup=true"

import "./AppAlerts.vue?vue&type=style&index=0&id=a3006912&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3006912"]])

export default __exports__